export default __webpack_public_path__ + "static/media/bar.a1d1bc51.png";